// Input validation on click
// Check input validity. Shows error if invalid at time of
// continuation / submission.
// ----------------------------------------------------------------

import $ from 'jquery';
import { inputValidationFunction } from './input-validation-function';

export function inputValidationOnClick(fieldset) {

    // Gets all inputs that need to be validated.
    var inputsToValidate = fieldset.find('input').filter('[required], [pattern]');

    $(inputsToValidate).each(function() {

        // Calls validation function.
        inputValidationFunction($(this));

    });

}
